import { render } from "./Controls.vue?vue&type=template&id=39f5b85a&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"

import "./Controls.vue?vue&type=style&index=0&id=39f5b85a&scoped=true&lang=css"

import exportComponent from "/home/jay/Code/dm-sokoban-leveleditor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f5b85a"]])

export default __exports__